import MetricDashboardIcon from '../components/icon/metricDashboard/MetricDashboardIcon';
import { PAGE_CREMATIONS, PAGE_ENQUIRIES, PAGE_ORDER_REQUESTS, PAGE_PLAQUES, PAGE_STOCK } from '../utils/strings';
import {
    ContactsIcon,
    DashboardIcon,
    EnquiriesIcon,
    FileIcon,
    FireIcon,
    InvoicingIcon,
    PlaqueSignIcon,
    StockIcon,
    UrnIcon,
    UsersIcon
} from '../components/IconIndex';
import { getServiceURLHostname } from '../utils/apollo';

export default [
    {
        path: '/',
        label: 'Dashboard',
        icon: DashboardIcon,
        permission: 'FM_ACCESS_Dashboard',
        items: [
            {
                path: '/metrics',
                permission: 'FM_ACCESS_metrics',
                label: 'Performance Metrics',
                icon: MetricDashboardIcon
            }
        ]
    },
    {
        path: PAGE_ENQUIRIES,
        label: 'Bookings',
        icon: EnquiriesIcon,
        permission: 'FM_ACCESS_Dashboard',
        items: [
            {
                path: PAGE_ORDER_REQUESTS,
                permission: 'FM_ACCESS_Dashboard',
                label: 'Booking Requests',
                icon: FileIcon
            }
        ]
    },
    {
        path: PAGE_CREMATIONS,
        label: 'Cremations',
        icon: UrnIcon,
        permission: 'FM_ACCESS_Dashboard',
        items: [
            {
                path: PAGE_CREMATIONS + 'scheduler',
                label: 'Scheduler',
                icon: FireIcon,
                permission: 'FM_ACCESS_Dashboard'
            }
        ]
    },
    {
        path: PAGE_PLAQUES,
        label: 'Plaques',
        icon: PlaqueSignIcon,
        permission: 'FM_ACCESS_Dashboard'
    },
    {
        path: '/contacts',
        label: 'Contacts',
        icon: ContactsIcon,
        permission: 'FM_ACCESS_Dashboard'
    },
    {
        path: '//' + getServiceURLHostname() + '/admin/reports',
        label: 'Reports (CMS)',
        icon: InvoicingIcon,
        newTab: true,
        permission: 'CMS_ACCESS_ReportAdmin'
    },
    {
        path: PAGE_STOCK,
        label: 'Catalogue',
        icon: StockIcon,
        permission: 'FM_ACCESS_Dashboard'
    },
    {
        path: '/users',
        label: 'Users',
        icon: UsersIcon,
        permission: 'FM_ACCESS_Dashboard'
    },
    {
        path: '/styles',
        label: 'Style Guide',
        icon: DashboardIcon,
        permission: 'CMS_ACCESS'
    }
];
